import { FunctionComponent } from 'react';
import { WagmiConfig, createClient, configureChains, Chain } from 'wagmi';
import { mainnet, goerli, localhost } from 'wagmi/chains';
import { InjectedConnector } from 'wagmi/connectors/injected';
import { WalletConnectConnector } from 'wagmi/connectors/walletConnect';
import { infuraProvider } from 'wagmi/providers/infura';
import { jsonRpcProvider } from 'wagmi/providers/jsonRpc';
import { ChainId, chainId, infuraId } from '@/lib/globals';

const chainsById: Record<ChainId, Chain[]> = {
    1: [mainnet],
    5: [goerli],
    1337: [localhost],
};

const providerInfo =
    chainId === 1337
        ? jsonRpcProvider({
              rpc: () => ({
                  http: `http://localhost:8545`,
              }),
          })
        : infuraProvider({ apiKey: infuraId });

const { chains, provider, webSocketProvider } = configureChains(chainsById[chainId], [providerInfo]);

const client = createClient({
    provider,
    webSocketProvider,
    connectors: [
        new InjectedConnector({ chains }),
        new WalletConnectConnector({
            chains,
            options: {
                projectId: '1d9a32c67a12784cce6b722bf9815358',
            },
        }),
    ],
});

export const WagmiProvider: FunctionComponent = ({ children }) => <WagmiConfig client={client}>{children}</WagmiConfig>;
